import React from 'react';
import clsx from 'clsx';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import { Bar, Pie } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/styles';
import SaveIcon from '@material-ui/icons/Save';
import ReactToPdf from 'react-to-pdf';
import {
    IconButton,
    Button,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Select,
    MenuItem,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors,
    InputLabel
} from '@material-ui/core';
import { get_agency_report, get_agencies } from '../../api/API';
import moment from 'moment/moment.js'
import Autocomplete from '@material-ui/lab/Autocomplete';
import './reports.css';
import DatePicker from 'react-date-picker';
import { CSVLink } from "react-csv";

const useStyles = makeStyles(theme => ({
    root: {
        padding: '24px',
    },

}));

export default class ReportAgency extends React.Component {


    constructor(props) {
        super(props);
        this.colors = ["rgba(0, 99, 132, 0.6)", "rgba(99, 132, 0, 0.6)", "#3efa9f", "#21decb", "#3c8ae8", "#8438e0", "#e038cc", "#f0328b", "#eb2f4e"];
        this.pieref = React.createRef();
        this.ref = React.createRef();
        this.state = {
            csv_output: [],
            csv_output_breakdown: [],
            start_print: false,
            start_print_pie: false,
            redraw: false,
            chartData: {},
            chart_option: {
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        },
                        ticks: {
                            min: 0,
                            max: 10,
                            stepSize: 1
                        }
                    }]
                }
            },
            agencies: [],
            values: {
                agencies: "",
                appointment_type: "all",
                date_from: (moment().subtract(7, 'days').format('YYYY-MM-DD')),
                date_to: (moment().format('YYYY-MM-DD')),
            },
            doughnuts: [],
            rawReport: []
        };
        // this.get_data();
        this.get_showroom_data();
    }
    handleChange(e) {
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [e.target.name]: e.target.value
            }
        }, () => {
            this.get_data();
        });

    }

    async get_showroom_data() {
        var currentObj = this;
        let agencies = await get_agencies();
        if (agencies) {
            currentObj.setState({
                ...this.state,
                agencies: agencies
            }, () => {
                // this.get_data();
            });
        }
    }

    parse_chart_data(data) {
        var labels = [];
        var datasets = [{
            label: 'Appointment: No Show',
            stack: "stack1",
            backgroundColor: '#bdbdbd',
            borderColor: '#bdbdbd',
            borderWidth: 1,
            hoverBackgroundColor: '#bdbdbd',
            hoverBorderColor: '#bdbdbd',
            data: []
        }, {
            label: 'Appointment:  Arrived',
            stack: "stack1",
            backgroundColor: '#66bb6a',
            borderColor: '#66bb6a',
            borderWidth: 1,
            hoverBackgroundColor: '#66bb6a',
            hoverBorderColor: '#66bb6a',
            data: []
        }, {
            label: 'Appointment: Booked',
            stack: "stack1",
            backgroundColor: '#42a5f5',
            borderColor: '#42a5f5',
            borderWidth: 1,
            hoverBackgroundColor: '#42a5f5',
            hoverBorderColor: '#42a5f5',
            data: []
        },
        {
            label: 'Guests: No Show',
            stack: "stack2",
            backgroundColor: 'rgba(189, 189, 189, 0.56)',
            borderColor: 'rgba(189, 189, 189, 0.56)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(189, 189, 189, 0.56)',
            hoverBorderColor: 'rgba(189, 189, 189, 0.56)',
            data: []
        },
        {
            label: 'Guests: Arrived',
            stack: "stack2",
            backgroundColor: 'rgba(102, 187, 106, 0.56)',
            borderColor: 'rgba(102, 187, 106, 0.56)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(102, 187, 106, 0.56)',
            hoverBorderColor: 'rgba(102, 187, 106, 0.56)',
            data: []
        },
        {
            label: 'Guests: Booked',
            stack: "stack2",
            backgroundColor: 'rgba(66, 165, 245, 0.56)',
            borderColor: 'rgba(66, 165, 245, 0.56)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(66, 165, 245, 0.56)',
            hoverBorderColor: 'rgba(66, 165, 245, 0.56)',
            data: []
        }
        ];


        var doughnuts = [];
        var max_y_tick = 5;
        for (var i = 0; i < data.length; i++) {
            labels.push(data[i].agency);
            max_y_tick = data[i].total > max_y_tick ? data[i].total : max_y_tick;
            datasets[0].data.push(data[i].no_show);
            datasets[1].data.push(data[i].arrived);
            datasets[2].data.push(data[i].total - data[i].no_show - data[i].arrived);
            datasets[3].data.push(data[i].no_show_pax);
            datasets[4].data.push(data[i].arrived_pax);
            datasets[5].data.push(data[i].total_pax - data[i].no_show_pax - data[i].arrived_pax);


            var doughnut_data = {};
            doughnuts.push({
                title: data[i].agency,
                labels: ["no show", "arrived"],
                datasets: [{
                    label: data[i].agency,
                    backgroundColor: ['#bdbdbd', "#66bb6a"],
                    borderColor: ['#bdbdbd', "#66bb6a"],
                    data: [data[i].no_show, data[i].arrived]
                }
                ]
            });

        }


        this.setState({
            ...this.state,
            chartData: {
                labels: labels,
                datasets: datasets,
            },
            chart_option: {

                scales: {
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        },
                        ticks: {
                            min: 0,
                            max: max_y_tick + 5,
                            stepSize: 1
                        }
                    }]
                }



            },
            rawReport: data,
            doughnuts: doughnuts
        }, this.downloadCSV);
    }

    async get_data() {
        var agencies = this.state.values.agencies;
        let agency_arr = '';
        for (var i = 0; i < agencies.length; i++) {
            if (i == 0) {
                agency_arr += agencies[i].agency_id;
            } else {
                agency_arr += ',' + agencies[i].agency_id;
            }

        }

        var data = await get_agency_report({
            ...this.state.values,
            agencies: agency_arr,
            date_from: moment(this.state.values.date_from).format("yyyy-MM-DD"),
            date_to: moment(this.state.values.date_to).format("yyyy-MM-DD"),
        });
        if (data) {
            this.parse_chart_data(data.data);
        }
    }

    handleChangeDate(date, field) {
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [field]: date
            }
        }, () => {
            this.get_data();
        });
    }

    downloadCSV() {
        var export_data = [];
        var header = ['', 'Appt. Arrived', 'Appt. No Show', "Appt. Booked", "Appt. Total", "Guest Arrived", "Guest No Show", "Guest Booked", "Guest Total"];

        export_data.push(header);

        this.state.rawReport.map(row => {

            export_data.push([
                row.agency,
                row.arrived,
                row.no_show,
                row.total - row.arrived - row.no_show,
                row.total,
                row.arrived_pax,
                row.no_show_pax,
                row.total_pax - row.arrived_pax - row.no_show_pax,
                row.total_pax
            ]);
        });
        this.setState({
            ...this.state,
            csv_output: export_data
        }, () => {
            console.log(this.state)
        }
        );
    }
    render() {
        return (
            <React.Fragment>
                <Header
                    classes={this.props.classes}
                    onSidebarOpen={this.props.handleSidebarOpen}
                />
                <Sidebar
                    classes={this.props.classes}
                    onClose={this.props.handleSidebarClose}
                    open={this.props.shouldOpenSidebar}
                    variant={this.props.isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={this.props.classes.content}>
                    <div className={this.props.classes.toolbar} />
                    <br></br>

                    <div
                        {...this.props}
                        className={clsx(this.props.classes.root, this.props.className)}
                        style={{
                            height: "auto",
                            padding: 8
                        }}
                    >
                        <Card>
                            <CardHeader
                                action={
                                    <>
                                        <ReactToPdf
                                            targetRef={this.ref}
                                            filename={"Agency_Report_" + this.state.values.date_from + "_" + this.state.values.date_to + ".pdf"}
                                            scale={0.8}
                                            x={1}
                                            y={0}
                                            onComplete={(() => {
                                                this.setState({
                                                    ...this.state,
                                                    start_print: false,
                                                    redraw: true
                                                })
                                            }).bind(this)}
                                        >
                                            {({ toPdf }) => (
                                                <IconButton
                                                    onClick={(() => {
                                                        window.scrollTo(0, 0);
                                                        this.setState({
                                                            ...this.state,
                                                            start_print: true,
                                                            redraw: true
                                                        }, () => {
                                                            setTimeout(() => {

                                                                toPdf();
                                                            }, 2000);
                                                        });

                                                    }).bind(this)}
                                                >
                                                    <SaveIcon style={{ color: "black" }} />
                                                </IconButton>
                                            )}
                                        </ReactToPdf>
                                        <IconButton

                                        >
                                            <CSVLink
                                                data={this.state.csv_output}
                                                filename={"Agency_Report_" + this.state.values.date_from + "_" + this.state.values.date_to + ".csv"}
                                            >
                                                <img style={{
                                                    width: 26
                                                }} src={require("../../assets/excel_icon.png")}></img>
                                            </CSVLink>
                                        </IconButton>
                                    </>
                                }
                                title="Agency Report"
                            />
                            <Divider />
                            <CardContent class="report_container" className={useStyles.content}>
                                <div
                                    className="report_filter multiselect_reports"
                                >
                                    <div className="filter_field_wrapper">
                                        <Autocomplete
                                            // style={{
                                            //     flexGrow: 1,
                                            //     marginRight: 20
                                            // }}
                                            multiple
                                            id="tags-standard"
                                            name="unit"
                                            options={this.state.agencies}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(event, newVal) => {
                                                this.setState({
                                                    ...this.state,
                                                    values: {
                                                        ...this.state.values,
                                                        agencies: newVal
                                                    }
                                                }, () => {
                                                    this.get_data();
                                                });
                                            }}
                                            renderInput={(params) => (

                                                <TextField
                                                    {...params}
                                                    style={{
                                                        width: "100%"
                                                    }}
                                                    label="Agency"
                                                    placeholder='select agency'
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className="filter_field_wrapper">

                                        <InputLabel shrink id="metric_label">
                                            Guest Type
                                        </InputLabel>

                                        <Select
                                            className="full_width"
                                            labelId="appointment_type"
                                            label="appointment_type"
                                            onChange={this.handleChange.bind(this)}
                                            name="appointment_type"
                                            value={this.state.values.appointment_type}
                                        >
                                            <MenuItem
                                                value="all">
                                                All
                                            </MenuItem>
                                            <MenuItem
                                                value="1">
                                                New Prospect
                                            </MenuItem>
                                            <MenuItem
                                                value="2">
                                                Prospect Revisit
                                            </MenuItem>
                                            <MenuItem
                                                value="3">
                                                Buyer Revisits
                                            </MenuItem>
                                        </Select>
                                    </div>
                                    <div className="filter_field_wrapper">
                                        <TextField
                                            type="date"
                                            name="date_from"
                                            label="From"
                                            className="full_width"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.values.date_from}

                                        />
                                    </div>
                                    <div className="filter_field_wrapper">
                                        <TextField

                                            type="date"
                                            name="date_to"
                                            label="to"
                                            className="full_width"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.values.date_to}

                                        />
                                    </div>

                                </div>
                                {!this.state.start_print_pie && (
                                    <div
                                        style={{
                                            width: this.state.start_print ? 900 : "auto"
                                        }}
                                        ref={this.ref}>
                                        {this.state.start_print && (
                                            <div style={{
                                                marginBottom: 30
                                            }}>
                                                <Grid container>
                                                    <Grid item md={3}>
                                                        <img src={require("../../assets/logo_small.png")}></img>
                                                        <p>Showing date: {this.state.values.date_from} to {this.state.values.date_to}</p></Grid>
                                                    <Grid item md={6} style={{
                                                        textAlign: 'center'
                                                    }}>
                                                        <h1>Agency Report</h1>
                                                    </Grid>
                                                </Grid>


                                            </div>
                                        )}
                                        <div style={{
                                            height: '60vh',
                                            maxHeight: '20vh'
                                        }}>
                                            <Bar
                                                width={this.state.start_print ? 900 : "auto"}
                                                redraw={this.state.redraw}
                                                options={{
                                                    ...this.state.chart_option,
                                                    maintainAspectRatio: false,
                                                    devicePixelRatio: 3
                                                }} data={this.state.chartData}></Bar>
                                        </div>

                                        <br></br>
                                        <br></br>
                                        <Table className="hide_mobile report_table">
                                            <TableHead>
                                                <TableRow >
                                                    <TableCell style={{
                                                        textAlign: "center",
                                                        backgroundColor: "black",
                                                        color: "white"
                                                    }}></TableCell>
                                                    <TableCell style={{
                                                        textAlign: "center",
                                                        backgroundColor: "black",
                                                        color: "white"
                                                    }}
                                                        colSpan={4}>Appointments</TableCell>
                                                    <TableCell
                                                        style={{
                                                            textAlign: "center",
                                                            backgroundColor: "black",
                                                            color: "white"
                                                        }}
                                                        colSpan={4}>Guests</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell></TableCell>
                                                    <TableCell
                                                    >Arrived</TableCell>
                                                    <TableCell>No Show</TableCell>
                                                    <TableCell>Booked</TableCell>
                                                    <TableCell
                                                        className="bold"
                                                    >Total</TableCell>
                                                    <TableCell
                                                        className="section_2"
                                                    >Arrived</TableCell>
                                                    <TableCell
                                                        className="section_2"
                                                    >No Show</TableCell>
                                                    <TableCell
                                                        className="section_2"
                                                    >Booked</TableCell>
                                                    <TableCell
                                                        className="bold section_2"
                                                    >Total</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {this.state.rawReport.map((row) => (
                                                    <TableRow>
                                                        <TableCell className="bold">{(row.agency)}</TableCell>
                                                        <TableCell>{row.arrived}</TableCell>
                                                        <TableCell>{row.no_show}</TableCell>
                                                        <TableCell>{row.total - row.arrived - row.no_show}</TableCell>
                                                        <TableCell className="bold">{row.total}</TableCell>
                                                        <TableCell className="section_2">{row.arrived_pax}</TableCell>
                                                        <TableCell className="section_2">{row.no_show_pax}</TableCell>
                                                        <TableCell className="section_2">{row.total_pax - row.arrived_pax - row.no_show_pax}</TableCell>
                                                        <TableCell className="section_2 bold">{row.total_pax}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>

                                        <Table className="hide_desktop report_table">
                                            <TableHead>
                                                <TableRow >
                                                    <TableCell style={{
                                                        textAlign: "center",
                                                        backgroundColor: "black",
                                                        color: "white"
                                                    }}></TableCell>
                                                    <TableCell style={{
                                                        textAlign: "center",
                                                        backgroundColor: "black",
                                                        color: "white"
                                                    }}
                                                        colSpan={4}>Appointments</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell></TableCell>
                                                    <TableCell
                                                    >Arrived</TableCell>
                                                    <TableCell>No Show</TableCell>
                                                    <TableCell>Booked</TableCell>
                                                    <TableCell
                                                        className="bold"
                                                    >Total</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {this.state.rawReport.map((row) => (
                                                    <TableRow>
                                                        <TableCell className="bold">{row.agency}</TableCell>
                                                        <TableCell>{row.arrived}</TableCell>
                                                        <TableCell>{row.no_show}</TableCell>
                                                        <TableCell>{row.total - row.arrived - row.no_show}</TableCell>
                                                        <TableCell className="bold">{row.total}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <Table className="hide_desktop report_table">
                                            <TableHead>
                                                <TableRow >
                                                    <TableCell style={{
                                                        textAlign: "center",
                                                        backgroundColor: "black",
                                                        color: "white"
                                                    }}></TableCell>
                                                    <TableCell
                                                        style={{
                                                            textAlign: "center",
                                                            backgroundColor: "black",
                                                            color: "white"
                                                        }}
                                                        colSpan={4}>Guests</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell></TableCell>

                                                    <TableCell
                                                        className="section_2"
                                                    >Arrived</TableCell>
                                                    <TableCell
                                                        className="section_2"
                                                    >No Show</TableCell>
                                                    <TableCell
                                                        className="section_2"
                                                    >Booked</TableCell>
                                                    <TableCell
                                                        className="bold section_2"
                                                    >Total</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {this.state.rawReport.map((row) => (
                                                    <TableRow>
                                                        <TableCell className="bold">{row.agency}</TableCell>
                                                        <TableCell className="section_2">{row.arrived_pax}</TableCell>
                                                        <TableCell className="section_2">{row.no_show_pax}</TableCell>
                                                        <TableCell className="section_2">{row.total_pax - row.arrived_pax - row.no_show_pax}</TableCell>
                                                        <TableCell className="section_2 bold">{row.total_pax}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <br></br>
                                        <br></br>

                                    </div>
                                )}
                                {1 == 2 && (
                                    <>
                                        <div
                                            style={{
                                                display: 'flex',
                                                marginLeft: "2%",
                                                marginRight: "2%",
                                                marginBottom: "2%",
                                                borderBottom: "1px solid black",

                                            }}
                                        >
                                            <h1>Report Breakdown</h1>
                                            <div
                                                style={{
                                                    flexGrow: 1,
                                                    textAlign: "right"
                                                }}
                                            >
                                                <ReactToPdf
                                                    targetRef={this.pieref}
                                                    filename={"Agency_Report_breakdown_" + this.state.values.date_from + "_" + this.state.values.date_to + ".pdf"}
                                                    scale={0.8}
                                                    x={2}
                                                    y={0}
                                                    onComplete={(() => {
                                                        this.setState({
                                                            ...this.state,
                                                            start_print_pie: false,
                                                            redraw: true
                                                        })
                                                    }).bind(this)}
                                                >
                                                    {({ toPdf }) => (
                                                        <IconButton
                                                            onClick={(() => {
                                                                window.scrollTo(0, 0);
                                                                this.setState({
                                                                    ...this.state,
                                                                    start_print_pie: true,
                                                                    redraw: true
                                                                }, () => {
                                                                    setTimeout(() => {

                                                                        toPdf();
                                                                    }, 2000);
                                                                });

                                                            }).bind(this)}
                                                        >
                                                            <SaveIcon style={{ color: "black" }} />
                                                        </IconButton>
                                                    )}
                                                </ReactToPdf>
                                                <IconButton

                                                >
                                                    <CSVLink
                                                        data={this.state.csv_output}
                                                        filename={"Agency_Report_" + this.state.values.date_from + "_" + this.state.values.date_to + ".csv"}
                                                    >
                                                        <img style={{
                                                            width: 26
                                                        }} src={require("../../assets/excel_icon.png")}></img>
                                                    </CSVLink>
                                                </IconButton>
                                            </div>
                                        </div>
                                        <div
                                            ref={this.pieref}
                                            style={{
                                                width: this.state.start_print_pie ? 900 : 'auto'
                                            }}
                                        >
                                            {this.state.start_print_pie && (
                                                <Grid container>
                                                    <Grid item md={3}>
                                                        <img src={require("../../assets/logo_small.png")}></img>
                                                        <p>Showing date: {this.state.values.date_from} to {this.state.values.date_to}</p></Grid>
                                                    <Grid item md={6} style={{
                                                        textAlign: 'center'
                                                    }}>
                                                        <h1>Agency Report Breakdown</h1>
                                                    </Grid>
                                                </Grid>
                                            )}
                                            <div style={{
                                                marginTop: 20
                                            }}>
                                                <Grid container className="doughnut_padding" spacing={1}>
                                                    {this.state.doughnuts.map(doughnut => (
                                                        <Grid item md={4}>
                                                            <h3>{doughnut.title}</h3>
                                                            <hr></hr>
                                                            <Pie data={doughnut}
                                                                redraw={this.state.redraw}
                                                            ></Pie>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                                <br></br>
                                                <br></br>
                                            </div>

                                        </div>
                                    </>
                                )}
                            </CardContent>
                        </Card>
                    </div>
                </main>
            </React.Fragment >
        )
    }
}
